const contactForm = () => {
  const selectSubject = (subject) => {
    const subjectList = document.querySelector('#contact .contact_subject');
    const optionSelected = subjectList.querySelector(`option[value="${subject}"]`);

    if (optionSelected) {
      optionSelected.selected = true;
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const url = new URL(window.location.href);
    const page = url.searchParams.get('form');

    history.pushState({}, 'Contact - Quies', `?form=${page}&subject=${value}`);
  };

  const init = () => {
    const url = new URL(window.location.href);
    const page = url.searchParams.get('form');
    const subject = url.searchParams.get('subject');

    if (page) {
      const subjectList = document.querySelector('#contact .contact_subject');
      const formElement = document.querySelector('#contact form');

      if (subjectList && formElement) {
        subjectList.addEventListener('change', handleChange);
        selectSubject(subject);
      }
    }
  };

  init();
};

export default contactForm;
